module.exports = __webpack_public_path__ + "img/fstbanner.e2e8789e.png";